import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { countryListLocal } from "../Components/CountryList";
function Register() {
    const [formData, setFormData] = useState({
        full_name: "",
        email: "",
        password: "",
        confirm_password: "",
        gender: "",
        country: "",
        city: "",
        address: "",
        // profile_image: null,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData({
            ...formData,
            [name]: type === "file" ? files[0] : value,
        });
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const validateForm = () => {
        let newErrors = {};

        if (!formData.full_name.trim()) {
            newErrors.full_name = "Full name is required";
        }
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Invalid email address";
        }
        if (!formData.password) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
        }
        if (!formData.confirm_password) {
            newErrors.confirm_password = "Confirm password is required";
        } else if (formData.confirm_password !== formData.password) {
            newErrors.confirm_password = "Passwords do not match";
        }
        if (!formData.gender) {
            newErrors.gender = "Gender is required";
        }
        if (!formData.country.trim()) {
            newErrors.country = "Country is required";
        }
        if (!formData.city.trim()) {
            newErrors.city = "City is required";
        }
        if (!formData.address.trim()) {
            newErrors.address = "Address is required";
        }
        // if (!formData.profile_image) {
        //     newErrors.profile_image = "Profile image is required";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true)
        try {
            // Build FormData for file upload
            const formDataToSend = new FormData();
            Object.keys(formData).forEach((key) => {
                formDataToSend.append(key, formData[key]);
            });

            // Send request
            const response = await fetch("https://admin.energybazzar.com/api/user/register", {
                method: "POST",
                body: formDataToSend, // ✅ send as FormData (not JSON)
            });

            const result = await response.json();
            setIsSubmitting(false)
            if (response.ok) {
                console.log("✅ Registered Successfully:", result);
                toast.success('Registration successful!')
                setFormData(
                    {
                        full_name: "",
                        email: "",
                        password: "",
                        confirm_password: "",
                        gender: "",
                        country: "",
                        city: "",
                        address: "",
                        // profile_image: null,
                    }
                )
            } else {
                console.error("Registration failed:", result);
                toast.success(result.message || "Something went wrong. Please try again.")
            }
        } catch (error) {
            setIsSubmitting(false)
            console.error("⚠️ Error:", error);
        }
    };

    return (
        <div className="register-wrapper">
            <div className="d-flex justify-content-center nnn align-items-center min-vh-100 bg-light">
                <div className="col-md-8 col-lg-6 col-xl-5 m-1">
                    <div className="card shadow-lg border-0 rounded-4">
                        <div className="card-body p-4">
                            <h3 className="text-center mb-4 fw-bold text-primary">
                                Create an Account
                            </h3>
                            <form onSubmit={handleSubmit} noValidate>
                                <div className="row">
                                    {/* Full Name */}
                                    <div className="col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Full Name</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                                            name="full_name"
                                            value={formData.full_name}
                                            onChange={handleChange}
                                        />
                                        {errors.full_name && (
                                            <div className="invalid-feedback">{errors.full_name}</div>
                                        )}
                                    </div>

                                    {/* Email */}
                                    <div className="col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && (
                                            <div className="invalid-feedback">{errors.email}</div>
                                        )}
                                    </div>

                                    {/* Password */}
                                    <div className="col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Password</label>
                                        <input
                                            type="password"
                                            className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                        />
                                        {errors.password && (
                                            <div className="invalid-feedback">{errors.password}</div>
                                        )}
                                    </div>

                                    {/* Confirm Password */}
                                    <div className="col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Confirm Password</label>
                                        <input
                                            type="password"
                                            className={`form-control ${errors.confirm_password ? "is-invalid" : ""}`}
                                            name="confirm_password"
                                            value={formData.confirm_password}
                                            onChange={handleChange}
                                        />
                                        {errors.confirm_password && (
                                            <div className="invalid-feedback">{errors.confirm_password}</div>
                                        )}
                                    </div>

                                    {/* Gender */}
                                    <div className="col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Gender</label>
                                        <select
                                            className={`form-select ${errors.gender ? "is-invalid" : ""}`}
                                            name="gender"
                                            value={formData.gender}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </select>
                                        {errors.gender && (
                                            <div className="invalid-feedback">{errors.gender}</div>
                                        )}
                                    </div>

                                    {/* Country */}
                                    <div className="col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Country</label>
                                        <select
                                            className={`form-select ${errors.country ? 'is-invalid' : ''}`}
                                            name="country"
                                            value={formData.country}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Country</option>
                                            {countryListLocal.item.sort((a, b) => a.name.common.localeCompare(b.name.common)).map((item, index) => (
                                                <option key={index} value={item.name.common}>{item.name.common}</option>
                                            ))}
                                        </select>
                                        {errors.country && (
                                            <div className="invalid-feedback">{errors.country}</div>
                                        )}
                                    </div>

                                    {/* City */}
                                    <div className="col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">City</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.city ? "is-invalid" : ""}`}
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                        />
                                        {errors.city && (
                                            <div className="invalid-feedback">{errors.city}</div>
                                        )}
                                    </div>

                                    {/* Address */}
                                    <div className="col-md-6 col-sm-12 mb-3">
                                        <label className="form-label">Address</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.address ? "is-invalid" : ""}`}
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                        />
                                        {errors.address && (
                                            <div className="invalid-feedback">{errors.address}</div>
                                        )}
                                    </div>

                                    {/* Profile Image */}
                                    {/* <div className="col-md-12 col-sm-12 mb-3">
                                        <label className="form-label">Profile Image</label>
                                        <input
                                            type="file"
                                            className={`form-control ${errors.profile_image ? "is-invalid" : ""}`}
                                            name="profile_image"
                                            onChange={handleChange}
                                        />
                                        {errors.profile_image && (
                                            <div className="invalid-feedback">{errors.profile_image}</div>
                                        )}
                                    </div> */}
                                </div>

                                {/* Submit */}
                                <button
                                    disabled={isSubmitting}
                                    type="submit"
                                    className="btn btn-primary w-100 py-2 rounded-3"
                                >
                                    {isSubmitting ? (
                                        <div
                                            className="spinner-border spinner-border-sm text-light me-2"
                                            role="status"
                                        >
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : 'Register'}

                                </button>
                            </form>

                            <p className="text-center mt-3">
                                Already have an account?{" "}
                                <NavLink to="/login" className="text-decoration-none fw-bold">
                                    Login
                                </NavLink>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Register;
